import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "../pages/HomePage";
import NotFoundPage from "../pages/NotFoundPage";
import ReviewPurchasePage from "../pages/ReviewPurchasePage";
import DisclaimerPage from "../pages/DisclaimerPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <DisclaimerPage />,
  },
  {
    path: "/instance",
    element: <HomePage />,
  },
  {
    path: "/review/:region/:instanceId",
    element: <ReviewPurchasePage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

function AppRouter() {
  return <RouterProvider router={router} />;
}

export default AppRouter;
